import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useRouter } from "next/router";

type Props = {
  onClose: () => void;
  onCreated: () => void;
  isRedirect?: boolean;
};

const Success = ({ onClose, onCreated, isRedirect }: Props) => {
  const router = useRouter();

  return (
    <Box sx={{ p: 3, pt: 4, textAlign: "center" }}>
      <CheckCircleIcon color="primary" sx={{ fontSize: "6rem" }} />
      <Typography align="center" gutterBottom variant="body1">
        Your brief is being created in the background. You can create another brief immediately while the first one processes.
      </Typography>
      <Box sx={{ pt: 3, textAlign: "center" }}>
        <Button
          variant="outlined"
          color="primary"
          type="button"
          onClick={() => {
            isRedirect ? router.push("/dashboard") : onClose();
          }}
          sx={{ mr: 3 }}
        >
          Return to dashboard
        </Button>
        <Button
          variant="contained"
          color="primary"
          type="button"
          onClick={onCreated}
        >
          Create another article
        </Button>
      </Box>
    </Box>
  );
};

export default Success;
